import { useCommentAvatar } from "@app/shared/hooks/use-comment-avatar.hook";
import type { User } from "@core/account/types";
import { UserRound } from "lucide-react";

type CommentAvatarProps = {
  user?: Partial<User>;
  className?: string;
};

export function CommentAvatar({ user, className = "" }: CommentAvatarProps) {
  const { imageUrl, initial, name } = useCommentAvatar(user);

  return imageUrl ? (
    <img
      src={imageUrl}
      alt={name}
      className={`h-10 w-10 shrink-0 rounded-full object-cover ${className}`}
    />
  ) : (
    <span
      aria-hidden="true"
      className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-gradient-to-br from-primary-500 to-violet-600 text-sm font-black text-white ${className}`}
    >
      {initial || <UserRound className="h-5 w-5" />}
    </span>
  );
}
